var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.86,
    height: 17.867,
    viewBox: "0 0 17.86 17.867",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "key",
    d: "M5.589,17.867A5.583,5.583,0,0,1,4.074,6.911a5.485,5.485,0,0,1,2.889-.036L12.85.989A3.35,3.35,0,0,1,15.237,0h0a2.635,2.635,0,0,1,2.632,2.632A3.356,3.356,0,0,1,16.88,5.02l-.5.5a1.5,1.5,0,0,1-1.053.436H14.147V6.7a1.489,1.489,0,0,1-1.489,1.489h-.744V9.37a1.478,1.478,0,0,1-.436,1.053l-.484.484a5.46,5.46,0,0,1-.035,2.888,5.6,5.6,0,0,1-4.785,4.042,5.7,5.7,0,0,1-.584.031Zm0-9.678a4.094,4.094,0,1,0,3.937,5.2,4.02,4.02,0,0,0-.074-2.457.744.744,0,0,1,.177-.771l.8-.8V8.189A1.489,1.489,0,0,1,11.913,6.7h.744V5.956a1.489,1.489,0,0,1,1.489-1.489h1.181l.5-.5a1.875,1.875,0,0,0,.552-1.334,1.144,1.144,0,0,0-1.143-1.143,1.876,1.876,0,0,0-1.335.553l-6.2,6.2a.744.744,0,0,1-.771.176,4.066,4.066,0,0,0-1.344-.231ZM3.725,13.4a.744.744,0,1,0,.744-.744A.744.744,0,0,0,3.725,13.4Z",
    transform: "translate(-0.009 0)",
    fill: "#c8102e"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.141db79bd49a1d1d52be69f2aa6d6e9c.svg";
export { ForwardRef as ReactComponent };